import React, { Component } from "react"
import theme from "../styles/theme"
import styled from "@emotion/styled"

import ImageLazy from "./ImageLazy"

const Outer = styled.div`
  padding: 0 32px;
`
const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 32px;
  align-items: flex-start;
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    grid-auto-flow: dense;
    &:first-of-type {
      grid-column: 2;
    }
  }
`

const Content = styled.div`
  width: 100%;
  a {
    color: ${theme.color.extended.blue};
  }
`

export default class MediaFeature extends Component {
  render() {
    return (
      <Outer>
        <Container>
          <Content>{this.props.content}</Content>
          <ImageLazy filename={this.props.filename} />
        </Container>
      </Outer>
    )
  }
}
